// extracted by mini-css-extract-plugin
export var redoItem = "_ma-1";
export var redoTrigger = "_ma-0";